import { useContext } from 'react';
import { useSelector } from 'react-redux';

import { widgetLoading } from '@swf/core/utils/widgets';
import { PokerContext } from '@swf/poker';

// TODO: Unit test it if it gets more complex.
const useIsWidgetLoading = () => {
  const loading = useSelector(widgetLoading);
  const {
    state: { isPolling }
  } = useContext(PokerContext);

  return !isPolling && loading;
};

export default useIsWidgetLoading;
